import { writable } from 'svelte/store';
import '../models/sport.model';
import { SkillSportModel } from '../models/skillSport.model';
export const SkillSports = writable([]);
export const LoadSkillSport = writable(new SkillSportModel());
